import React from 'react';
import { useSelector } from 'react-redux';

const CallToActionButton = () => {
  const { language } = useSelector(state => state.Language);
  const municipality = useSelector(state => state.MunicipalityReducer);

  return (
    <button
      aria-label={municipality.callToActionButton[language].label}
      onClick={() => {
        window.location.href = municipality.callToActionButton.url;
      }}
      className="call-to-action-button btn-content"
    >
      <p>{municipality.callToActionButton[language].label}</p>
    </button>
  );
};

export default CallToActionButton;



// WEBPACK FOOTER //
// ./src/Components/CallToActionButton.js